var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatplotlib(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    stroke: "gray",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 88
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90,2v176m62-26-124-124m124,0-124,124m150-62H2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#44C",
    d: "m90,90h18a18,18 0 0,0 0-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC3",
    d: "m90,90 34-43a55,55 0 0,0-15-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D93",
    d: "m90,90-16-72a74,74 0 0,0-31,15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3",
    d: "m90,90-58-28a65,65 0 0,0-5,39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3BB",
    d: "m90,90-33,16a37,37 0 0,0 2,5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C9",
    d: "m90,90-10,45a46,46 0 0,0 18,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D73",
    d: "m90,90 46,58a74,74 0 0,0 12-12z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatplotlib);
export default __webpack_public_path__ + "static/media/matplotlib.a3a9e876bf96ccd5271110dac8098368.svg";
export { ForwardRef as ReactComponent };